// Every state a «Entrega» can be in, as the wire spells them.
//
// Written out as literals rather than imported from the app's own state vocabulary: that module
// lives in `apps/lockers/care/src/lib/`, and a package reaching up into an app inverts the
// dependency. Literals are also what the wire actually sends, which is the point of a mock.
const DELIVERY_STATES = [
  'stored',
  'collected',
  'expired',
  'non_collected',
  'retrieved',
  'non_retrieved',
  'rejected',
  'blocked',
  'cancelled',
  'failed',
];

export async function fetchDeliveryStatesMock(): Promise<string[]> {
  // Simulate network latency for a realistic dev experience.
  await new Promise((resolve) => setTimeout(resolve, 100));
  return DELIVERY_STATES;
}
